export const hasOwnProperty = <T extends object>(obj: T, property: string) => {
  return Object.prototype.hasOwnProperty.call(obj, property);
};

export const hasAllProperties = <T extends object>(obj: T, properties: string[]) => {
  return properties.every((property) => {
    return hasOwnProperty(obj, property);
  });
};
